<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !isEdit ? $t('categories.creation') : $t('categories.modification') }}</h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                    fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                    fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-name`"
                  type="text"
                  :label="$t('categories.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('categories.name_placeholder')"
                  v-model="formData.name"
              />
              <Select2
                  :parent-id="`#${id}`"
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-sub-categories`"
                  :multiple="true"
                  :label="$t('categories.subcategories')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :placeholderText="$t('categories.subcategories_placeholder')"
                  v-model="formData.categories"
              >
                <option v-for="(category, index) in filterCategories" :key="id+index" :value="category.id">
                  {{ category.name }}
                </option>
              </Select2>
            </div>

            <ImageInput class="" v-model:image="formData.image" :model-image="formData.image_url" containerClass="mb-10 text-center" imageClass="rounded-circle"/>

           
          </div>
          <div class="modal-footer">
              <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
              <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, defineEmits, defineProps, computed, onMounted, watch} from "vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import ImageInput from "@/components/ImageInput.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"

const store = useStore()
const emits = defineEmits(['afterUpdate', 'afterCreate'])
const props = defineProps({
  id: { type: String, required: true},
  isEdit: { type: Boolean, default: false},
  category : {
    type: Object,
    default: () => ({
      id: null,
      name: '',
      image: null,
      categories: [],
      online: true,
      image_url: null
    })
  }
})

const processing = ref(false)
const formData = ref(props.category)
const categories = computed(() => store.getters['categories/getCategories'])
const filterCategories = computed(() => {
  return categories.value ? categories.value.filter(category => category.id !== formData.value.id) : [];
})

function submitForm () {
  props.isEdit ? updateCategory() : createCategory()
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function updateCategory() {
  processing.value = true
  store.dispatch('categories/updateCategory', formData.value)
      .then(async(res) => {
        let delete_image = props.category?.image_url && (formData.value.image instanceof File || formData.value.image == null) ? true : false
        let image = (formData.value.image instanceof File) ? formData.value.image : null
        let imageData = new FormData()
        imageData.append('image', image);
        imageData.append('category_id', res.data.category.id);
        imageData.append('delete_image', delete_image);

        await store.dispatch('categories/uploadImage', imageData)
        loadData()
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("notification.category_updated"))
        emits('afterUpdate')
      })
      .finally(() => processing.value = false)
}

function createCategory() {
  processing.value = true
  
  store.dispatch('categories/createCategory', formData.value)
      .then(res => {
        loadData()
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("notification.category_created"))
        emits('afterCreate', res.data?.category?.id)
      })
      .finally(() => processing.value = false)
}

function loadData() {
  Promise.all([
      store.dispatch('categories/loadCategories')
  ])
}

onMounted(() => {
  loadData()
})


</script>

<style scoped></style>
